/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Paused_Spaces_View_SpacesInputs */



/**
* | output |
* | --- |
* | "View spaces" |
*
* @param {Project_Paused_Spaces_View_SpacesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_paused_spaces_view_spaces = /** @type {((inputs?: Project_Paused_Spaces_View_SpacesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Paused_Spaces_View_SpacesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Spaces anzeigen")
	return /** @type {LocalizedString} */ ("View spaces")
});